function isGenerator(type) {
    return typeof type === "function";
}

export { isGenerator };
